import { Button, Heading, Icon, IconButton, Input, Select, Stack, Table, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaCheck, FaEdit, FaPlus, FaReceipt, FaSync, FaTrash } from "react-icons/fa";
import ImportCSVButton from "../../components/Buttons/ImportCSVButton";
import { RiContactsBookFill } from "react-icons/ri";
import { useSelector } from "react-redux";
import { GET, POST } from "../../utils/ApiRequestProvider";


export default function VATGSTRates() {
    const business = useSelector((state: any) => state.selections.value?.business);
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [items, setItems] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(true);

    const [form, setForm] = useState<any>({
        id: 0,
        name: '',
        percentage: '',
        status: 'Active'
    });

    async function Save() {
        try {
            setLoading(true);

            const response = await POST(
                '/api/vatgst',
                {
                    ...form,
                    businessId: business.id
                }
            );
            toast({
                status: response.status,
                title: response.message,
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });

            setLoading(false);

            if (response.status === 'success') {
                FetchList();
                setForm({ name: '', percentage: '', status: '' });
                onClose();
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    async function Edit(data: any) {
        try {
            setForm({
                name: data.name,
                percentage: data.percentage,
                status: data.status
            });
            onOpen();
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    async function Delete(data: any) {
        try {
            setForm({
                name: data.name,
                percentage: data.percentage,
                status: data.status
            });
            onOpen();
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    async function CloseModel() {
        setForm({ name: '', percentage: '', status: 'Active' });
        onClose();
    }

    async function RefreshPage() {
        setLoading(true);
        setTimeout(() => {FetchList();setLoading(false)}, 1000);
    }

    useEffect(() => {
        FetchList();
        setTimeout(() => {setLoading(false)}, 1000);
        // setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [business]);

    async function FetchList() {
        try {
            if (business) {
                const res = await GET(`/api/vatgst/${business.id}`);
                setItems(res.data);
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Modal
                isCentered
                size={'3xl'}
                isOpen={isOpen}
                onClose={onClose}
            >
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px)'
                />
                <ModalContent>
                    <ModalHeader
                        as={Stack}
                        direction={'row'}
                        borderBottom={'2px'}
                        borderBottomColor={'gray.300'}
                    >
                        <Icon
                            as={RiContactsBookFill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'md'} fontFamily={'poppins'}>Add VAT/GST Scheme</Heading>
                        </Stack>
                    </ModalHeader>
                    <ModalBody as={Stack} direction={'row'} spacing={4} py={8}>
                        <Stack spacing={4} w={'full'}>
                            <Input
                                placeholder={'VAT/GST Scheme'}
                                type={'text'}
                                value={form.name}
                                onChange={e => setForm({ ...form, name: e.target.value })}
                            />
                            <Input
                                placeholder={'VAT/GST %'}
                                type={'number'}
                                value={form.percentage}
                                onChange={e => setForm({ ...form, percentage: e.target.value })}
                            />
                            <Select
                                onChange={e => setForm({ ...form, status: e.target.value })}
                                defaultValue={form.status}
                            >
                                <option value='Active'>Active</option>
                                <option value='Deactivated'>Deactivated</option>
                                <option value='Registered'>Registered</option>
                            </Select>
                        </Stack>
                    </ModalBody>
                    <ModalFooter
                        as={Stack}
                        direction={'row'}
                        spacing={4}
                        borderTop={'2px'}
                        borderTopColor={'gray.300'}
                    >
                        <Button
                            w={'full'}
                            onClick={CloseModel}
                        >
                            Close
                        </Button>
                        <Button
                            w={'full'}
                            onClick={Save}
                            leftIcon={<FaCheck />}
                            colorScheme={'primary'}
                            isLoading={loading}
                        >
                            Save
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
                align={'center'}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={FaReceipt}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>VAT / GST Rates</Heading>
                            <Text fontSize={'sm'}>Define your VAT / GST Rates & Schemes here.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Button
                            size={'sm'}
                            leftIcon={<FaPlus />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            onClick={onOpen}
                        >
                            Add VAT/GST Scheme
                        </Button>
                        <ImportCSVButton
                            endpoint={business ? `/api/vatgst/${business.id}/import` : '/api/vatgst/import'}
                            label={'Import VAT/GST Rates'}
                            onImported={() => FetchList()}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        />
                        <Button
                            size={'sm'}
                            leftIcon={<FaSync />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            onClick={RefreshPage}
                            isLoading={loading}
                        >
                            Refresh
                        </Button>
                    </Stack>
                </Stack>
            </Stack>
            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4} >
                <TableContainer>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    color={'white'}
                                >
                                    VAT/GST Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    VAT/GST %
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Status
                                </Th>
                                <Th color={'white'}>
                                    Action
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                loading ? (
                                    <Tr>
                                        <Td colSpan={4} textAlign={'center'}>Loading...</Td>
                                    </Tr>
                                ) : 
                                items?.length === 0 ? (
                                    <Tr>
                                        <Td colSpan={4} textAlign={'center'}>No Data Found!</Td>
                                    </Tr>
                                ) :
                                items.map(item => (
                                    <Tr>
                                        <Td>{item.name}</Td>
                                        <Td>{item.percentage}</Td>
                                        <Td>{item.status}</Td>
                                        <Td as={Stack} direction={'row'} justify={'start'} spacing={4}>
                                            <IconButton
                                                aria-label="Edit VAT"
                                                icon={<FaEdit />}
                                                size={'md'}
                                                bg={'transparent'}
                                                color={'primary.400'}
                                                rounded={'full'}
                                                onClick={() => Edit(item)}
                                            />
                                            <IconButton
                                                aria-label="Delete VAT"
                                                icon={<FaTrash />}
                                                size={'md'}
                                                bg={'transparent'}
                                                color={'red.400'}
                                                rounded={'full'}
                                                onClick={() => Delete(item)}
                                            />
                                        </Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                {/* <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack> */}
            </Stack>
        </Stack >
    )
}